import { ApiModule } from '../../api/services';
import type { HtmlContent } from '../model';

export class HtmlContentApi extends ApiModule {
  public loadContent(key: string, lang: string) {
    return this.api.get<HtmlContent>(`/tech/htmlblock/${key}/${lang}`);
  }
}
